import { render } from "./dogGroomingBannerComponent.vue?vue&type=template&id=47fd1b4a"
import script from "./dogGroomingBannerComponent.vue?vue&type=script&lang=js"
export * from "./dogGroomingBannerComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__